import { BaseSystemModel, Guid, RecursivePartial } from '@models/base';
import { TaskLayoutBlock } from './task-layout-block';

export class TaskTypeDef extends BaseSystemModel {
    orgId: Guid = '';
    projectId: Guid = '';
    workflowId: Guid = '';

    name: string = '';
    description?: string;
    color?: string;
    icon?: string;
    isMain?: boolean;

    layout: TaskLayoutBlock[] = [];

    constructor(json?: RecursivePartial<TaskTypeDef>) {
        super(json);
        this.parseTaskTypeDef(json || {});
    }

    parse(json: RecursivePartial<TaskTypeDef>): TaskTypeDef {
        super.parse(json);
        this.parseTaskTypeDef(json);
        return this;
    }

    private parseTaskTypeDef(json: RecursivePartial<TaskTypeDef>): void {
        TaskTypeDef.assignFields(this, json, ['orgId', 'projectId', 'workflowId', 'name', 'description', 'color', 'icon', 'isMain']);
        TaskTypeDef.assignClassArrays(this, json, { layout: TaskLayoutBlock });
        if (this.color == 'transparent') {
            this.color = undefined;
        }
    }

}

export function setBlocksPath(blocks: TaskLayoutBlock[] | undefined, path: string): TaskLayoutBlock[] | undefined {
    if (blocks?.length) {
        for (let i = 0; i < blocks.length; i++) {
            const b = blocks[i];
            b._path = path + i + '/';
            if (b.type == TaskLayoutBlock.Type.Container && b?.children?.length) {
                setBlocksPath(b.children!, b._path);
            }
        }
    }
    return blocks;
}
